import { useEffect, useState } from 'react';
import {
  formatDate,
  getWeeksBetween,
  getCurrentWeekDates,
} from '../../../../../lib/date';
import { ReactComponent as CrownSvg } from '../../../../../assets/svg/crown.svg';
import Bar from '../../../../../components/progress/bar';
import request from '../../../../../lib/request';

const ProgramInfo = ({ user }) => {
  const [currentProgram, setCurrentProgram] = useState({});
  const [totalWeeks, setTotalWeeks] = useState(1);
  const [currentWeek, setCurrentWeek] = useState(null);

  useEffect(() => {
    if (user?.programRegistered) {
      getCurrentProgram();
    }
  }, []);

  const getCurrentProgram = async () => {
    try {
      const { result } = await request.get('/program');

      if (result) {
        setCurrentProgram(result);

        const currentWeekDates = getCurrentWeekDates();
        const weeks = getWeeksBetween(result.startDate, result.endDate);
        setTotalWeeks(weeks.length);

        const weekNow = weeks.find(
          (week) =>
            currentWeekDates.includes(week.startDate) ||
            currentWeekDates.includes(week.endDate)
        );
        setCurrentWeek(weekNow.week);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div
      className={`relative overflow-hidden rounded-xl bg-gradient-to-br from-slate-500/30 to-slate-600/20 border border-slate-400/30 p-4 col-span-2`}
    >
      {/* Decorative elements */}
      <div className='absolute top-0 right-0 w-24 h-24 bg-slate-400/5 rounded-full -translate-y-1/2 translate-x-1/2'></div>
      <div className='absolute bottom-0 left-0 w-32 h-32 bg-slate-400/5 rounded-full translate-y-1/2 -translate-x-1/2'></div>

      {/* Content */}
      <div className='relative flex flex-col h-full'>
        <div className='flex items-center gap-2 mb-3 text-sm'>
          <div className='bg-slate-400/20 p-1 rounded-lg'>
            <CrownSvg className='size-3 text-slate-300' />
          </div>
          <div className='font-bold text-slate-300'>
            {currentProgram.program?.title}
          </div>
        </div>

        <div className='text-xs text-white flex flex-col justify-between h-full'>
          <div className='space-y-2'>
            <div>
              {formatDate(new Date(currentProgram.startDate))} -{' '}
              {formatDate(new Date(currentProgram.endDate))}{' '}
              <span className='text-gray-400'>({totalWeeks} weeks)</span>
            </div>
          </div>
          <div className='mt-2'>
            <Bar
              title='Progress'
              percentage={currentWeek ? (currentWeek / totalWeeks) * 100 : 0}
              current={currentWeek ? currentWeek : 0}
              total={totalWeeks}
              color='#FFD93D'
              unit='weeks'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgramInfo;
